import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import myImg from "../../Assets/shubhamkumar.png";
import Tilt from "react-parallax-tilt";
import { SiGmail } from "react-icons/si";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import pdf from "../../Assets/../Assets/shubhamresume.pdf";
// import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import AboutCard from "../About/AboutCard";
import Type from "./Type";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            {/* <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1> */}
            <h1 style={{ paddingBottom: 15 }} className="heading">
              Hi There!{" "}
              <span className="wave" role="img" aria-labelledby="wave">
                👋🏻
              </span>
            </h1>
            <br />
            <h1 className="heading-name">
              I'M
              <strong className="main-name"> SHUBHAM KUMAR</strong>
            </h1>
            <br />
            <Type />
            <br />

            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
             
              <br />I am fluent in
              <i>
                <b className="purple">
                  {" "}
                  Javascript, HTML, CSS, React, MongoDB, Redux, Express, Node{" "}
                </b>
              </i>
              <br />
              <br />
              <Row style={{ justifyContent: "center", position: "relative" }}>
                <Button variant="primary" href={pdf} target="_blank">
                  <AiOutlineDownload />
                  &nbsp;Download Resume
                </Button>
              </Row>
              <br />            
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">Fitness and exploring Mysteries.</b>
              </i>
              <br />
              {/* <AboutCard /> */}
              <br />
              {/* <h1 style={{ fontSize: "2.5em", paddingBottom: "20px" }}>
                  Check My Resume <strong className="purple">here</strong>
                </h1> */}
            
              {/* Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <h1 style={{color:"white", }}>FIND ME ON</h1>
              <ul  className="home-about-social-links">
                {/* <Button>
    <a
      href="https://github.com/Shubhamfw13"
      target="_blank"
      rel="noreferrer"
      className="icon-colour  home-social-icons"
    >
      <AiFillGithub />
    </a>
    sk9112019@gmail.com
  </Button> */}
                
                {/* Feel free to <span className="purple">connect </span>with me */}
               
                <br />
                <li  className="social-icons">
                  <a
                    href="mailto:sk9112019@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <SiGmail />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://github.com/Shubhamfw13"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/shubham-kumar-929356230/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              </ul>
      </Container>
    </Container>
  );
}
export default Home2;
